/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect } from "react";
import FormCreator from "../../components/Forms/FormCreator";
import Buttons from "../../components/ui/button/Buttons";
import forgetPasswordFormData from "./data/ForgetPasswordForm.data";
import { Link, useNavigate } from "react-router-dom";
import ToastService from "../../services/toastService/ToastService";
import { useForgotPasswordMemberMutation } from "../../app/services/GMAP/login";

const ForgetPasswordForm = () => {
  const formRef = useRef();
  const navigate = useNavigate();

  const [forgotPassword, { isLoading, isSuccess, data: apiData, isError, error }] = useForgotPasswordMemberMutation();

  useEffect(() => {
    if (!isLoading && isSuccess) {
      if (apiData === false || (apiData && apiData.isSuccess === false)) {
        // Error handling if response specifies success: false
        ToastService.error(apiData.message || "Failed to reset password. Please try again.");
      } else {
        ToastService.success("Password reset link has been sent to your email.", "Success");
        setTimeout(() => {
          navigate("/login");
        }, 3000);
      }
    }
  }, [isLoading, isSuccess, apiData]);

  useEffect(() => {
    if (isError && error) {
      ToastService.error(error?.data?.message || "An error occurred. Please try again.");
    }
  }, [isError, error]);

  const handleResetPassword = () => {
    const formData = formRef.current?.getFormData();
    if (!formData) return;

    const request = {
      emailAddress: formData.emailAddress,
    };

    forgotPassword(request);
  };

  return (
    <div className="login-form-section">
      <FormCreator
        ref={formRef}
        {...forgetPasswordFormData}
      />
      <div className="button-part">
        <Buttons
          buttonTypeClassName="btn success-btn"
          buttonText="Reset your password"
          onClick={handleResetPassword}
          isLoading={isLoading}
        />
      </div>
      <div className="back-to-login" style={{ textAlign: "center", marginTop: "15px" }}>
        <Link to="/login" className="font-medium text-[#329a03] hover:text-[#297407]" style={{ fontSize: "14px", fontWeight: "600" }}>
          Back to Login
        </Link>
      </div>
    </div>
  );
};

export default ForgetPasswordForm;
